"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24TrashLine = function Svg24TrashLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h4a1 1 0 1 1 0 2h-.5c0 .028 0 .055-.002.083l-.469 11.26a5.677 5.677 0 0 1-.032.45 2.503 2.503 0 0 1-.283.906 2.5 2.5 0 0 1-1.086 1.042c-.373.184-.716.23-.919.246-.164.013-.342.013-.45.013H8.741c-.108 0-.286 0-.45-.013a2.503 2.503 0 0 1-.918-.245 2.5 2.5 0 0 1-1.087-1.043 2.504 2.504 0 0 1-.284-.907 5.726 5.726 0 0 1-.031-.449L5.5 7.083A1.997 1.997 0 0 1 5.5 7H5a1 1 0 0 1 0-2h4V4zM7.5 7l.468 11.233c.011.27.017.404.073.507a.5.5 0 0 0 .217.208c.105.052.24.052.51.052h6.465c.27 0 .404 0 .509-.052a.5.5 0 0 0 .217-.208c.056-.102.062-.237.073-.507L16.5 7h-9z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24TrashLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24TrashLine;
exports.default = _default;